import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { withStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardBody,
  GridContainer,
  GridItem,
} from "~/shared/components/MuiComponents.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import imgBlueberry from "~assets/images/flavors/sleep-blueberry.png";
import imgGreenApple from "~assets/images/flavors/sleep-green-apple.png";
import imgRaspberryLemonade from "~assets/images/flavors/sleep-raspberry-lemonade.png";
import imgTangerine from "~assets/images/flavors/sleep-tangerine.png";
import imgSleepTrial from "~assets/images/visits/Sleep_Web_Bottle.png";

import {
  clearOrderItemSubcategory,
  getOrderItemSubcategory,
  getVisitID,
  getVisitUSState,
  setOrderItemSubcategory,
} from "~/visits/utils/visitCookies";

import {
  BLUEBERRY_FLAVOR,
  COLOR_KICK_BLUE,
  GREEN_APPLE_FLAVOR,
  RASPBERRY_LEMONADE_FLAVOR,
  TANGERINE_FLAVOR,
} from "~/shared/sharedConstants.js";

import { supportedUSStatesForCompoundedMeds } from "~/shared/utils/sharedUtils";

import { kickBlue } from "~/shared/styles/baseStyles";

const COMMERCIAL_ONLY = "COMMERCIAL_ONLY";

const flavors = [
  {
    name: "Blueberry",
    image: imgBlueberry,
    flavorConst: BLUEBERRY_FLAVOR,
    longDescription:
      "Sweet and soothing blueberry flavor in a calming bedtime gummy.",
  },
  {
    name: "Green Apple",
    image: imgGreenApple,
    flavorConst: GREEN_APPLE_FLAVOR,
    longDescription:
      "Crisp green apple flavor to help you unwind before sleep.",
  },
  {
    name: "Tangerine",
    image: imgTangerine,
    flavorConst: TANGERINE_FLAVOR,
    longDescription:
      "Bright, juicy tangerine flavor in a relaxing bedtime gummy.",
  },
  {
    name: "Raspberry Lemonade",
    image: imgRaspberryLemonade,
    flavorConst: RASPBERRY_LEMONADE_FLAVOR,
    longDescription:
      "Refreshing raspberry lemonade flavor for a peaceful night's rest.",
  },
];

const SelectSleepFlavored = ({ classes, history, match }) => {
  const consultationType = match.params.consultationType;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const checkoutSessionID = queryParams.get("checkoutSessionID");
  if (!checkoutSessionID) {
    window.location.href = "/me/portal";
  }

  const [selectedFlavor, setSelectedFlavor] = useState(
    getOrderItemSubcategory(consultationType, checkoutSessionID) || null,
  );
  const [showError, setShowError] = useState(false);

  const orderDetailsUrl = `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`;

  useEffect(() => {
    if (!getVisitID(checkoutSessionID)) {
      window.location.href = "/me/portal";
      return;
    }

    const visitIDCheckPoller = setInterval(() => {
      if (!getVisitID(checkoutSessionID)) {
        window.location.href = "/me/portal";
      }
    }, 1000);

    if (!supportedUSStatesForCompoundedMeds.includes(getVisitUSState())) {
      history.replace(orderDetailsUrl);
    }

    return () => clearInterval(visitIDCheckPoller);
  }, []);

  const handleSelection = (flavor) => {
    setSelectedFlavor(flavor);
    setShowError(false);
  };

  const nextQuestion = () => {
    if (selectedFlavor === null) {
      setShowError(true);
      return;
    }

    if (selectedFlavor === COMMERCIAL_ONLY) {
      clearOrderItemSubcategory(consultationType, checkoutSessionID);
    } else {
      setOrderItemSubcategory(
        consultationType,
        selectedFlavor,
        checkoutSessionID,
      );
    }
    history.push(orderDetailsUrl);
    window.scrollTo(0, 0);
  };

  const skipSelection = () => {
    clearOrderItemSubcategory(consultationType, checkoutSessionID);
    history.push(orderDetailsUrl);
    window.scrollTo(0, 0);
  };

  const isSelected = (flavorConst) => {
    return selectedFlavor === flavorConst;
  };

  return (
    <div
      className={classes.container}
      style={{ backgroundColor: COLOR_KICK_BLUE }}
    >
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={10} md={6}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            Want to Try Our Flavored Options?
          </h3>
          <p
            style={{
              color: "#FFFFFF",
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
            }}
          >
            Our compounded prescription sleep gummies come in four delicious
            flavors. Pick your favorite, or stick with the standard commercial
            option.
            <br />
            <br />
          </p>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}></GridItem>
        <GridItem xs={12} sm={10} md={6}>
          <Card
            className={classes.cardConsultation}
            style={{ paddingTop: "20px", paddingBottom: "20px" }}
          >
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              <div>
                <div
                  className={classes.selectFlavoredProductWrapper}
                  style={{
                    overflow: "hidden",
                    backgroundColor: isSelected(COMMERCIAL_ONLY)
                      ? "#fff7e5"
                      : "",
                  }}
                  onClick={() => handleSelection(COMMERCIAL_ONLY)}
                >
                  <img
                    src={imgSleepTrial}
                    style={{
                      position: "relative",
                      width: "200px",
                      height: "200px",
                      objectFit: "contain",
                    }}
                    alt="Standard Sleep Medication"
                  />
                  <div className={classes.selectFlavorImageTitleWrapper}>
                    <h4
                      className={classes.selectFlavorImageTitle}
                      style={{
                        color: kickBlue,
                        fontWeight: "bold",
                      }}
                    >
                      No Thanks — Commercial Only
                    </h4>
                    <p
                      style={{
                        marginTop: "4px",
                        marginBottom: "8px",
                        fontSize: "16px",
                      }}
                    >
                      Standard prescription sleep medication.
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    height: "1px",
                    margin: "0 25%",
                    backgroundColor: "#aaa",
                  }}
                />
              </div>
              {flavors.map((flavor, idx) => {
                return (
                  <div key={flavor.flavorConst}>
                    <div
                      className={classes.selectFlavoredProductWrapper}
                      style={{
                        overflow: "hidden",
                        backgroundColor: isSelected(flavor.flavorConst)
                          ? "#fff7e5"
                          : "",
                      }}
                      onClick={() => handleSelection(flavor.flavorConst)}
                    >
                      <img
                        src={flavor.image}
                        style={{
                          position: "relative",
                          width: "200px",
                          height: "200px",
                        }}
                        alt={`${flavor.name} Flavor`}
                      />
                      <div className={classes.selectFlavorImageTitleWrapper}>
                        <h4
                          className={classes.selectFlavorImageTitle}
                          style={{
                            color: kickBlue,
                            fontWeight: "bold",
                          }}
                        >
                          {flavor.name}
                        </h4>
                        <p
                          style={{
                            marginTop: "4px",
                            marginBottom: "8px",
                            fontSize: "16px",
                          }}
                        >
                          {flavor.longDescription}
                        </p>
                      </div>
                    </div>
                    {idx !== flavors.length - 1 && (
                      <div
                        style={{
                          height: "1px",
                          margin: "0 25%",
                          backgroundColor: "#aaa",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </CardBody>
          </Card>
          <div style={{ color: "red", margin: "20px auto 6px auto" }}>
            <p style={{ textAlign: "center" }}>
              {showError ? "Please select a flavor above" : ""}
            </p>
          </div>
          <Button
            onClick={() => {
              nextQuestion();
            }}
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "16px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
          <Button
            onClick={() => {
              skipSelection();
            }}
            style={{
              display: "block",
              backgroundColor: "transparent",
              color: "#FFFFFF",
              margin: "0 auto 30px auto",
              width: "300px",
              fontSize: "16px",
              fontWeight: "medium",
              textTransform: "unset",
              boxShadow: "none",
              textDecoration: "underline",
            }}
          >
            No preference - skip
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(SelectSleepFlavored);
